// Visitors may browse the home page, the book list and a book detail without
// signing in; everything else sends them to the login page, which brings them
// back to where they were once they have signed in.

export const LOGIN_ROUTE = '/login';
export const DEFAULT_LANDING_ROUTE = '/store/home';
const REDIRECT_PARAM = 'redirect';

interface LocationLike {
  pathname: string;
  search?: string;
  hash?: string;
}

/** Login page url that returns to `location` after signing in. */
export const loginPathFor = (location: LocationLike): string => {
  const origin = `${location.pathname}${location.search ?? ''}${location.hash ?? ''}`;
  return `${LOGIN_ROUTE}?${REDIRECT_PARAM}=${encodeURIComponent(origin)}`;
};

/** Where to go after signing in: the `redirect` parameter when it is a path
 *  inside this app, otherwise the home page. Anything else (another site,
 *  `//host`, `/\host`, the login page itself) is ignored so the parameter
 *  cannot send a user off-site. */
export const redirectTarget = (search: string | URLSearchParams): string => {
  const params = typeof search === 'string' ? new URLSearchParams(search) : search;
  const target = params.get(REDIRECT_PARAM);
  if (
    !target ||
    !target.startsWith('/') ||
    target.startsWith('//') ||
    target.startsWith('/\\') ||
    target === LOGIN_ROUTE ||
    target.startsWith(`${LOGIN_ROUTE}?`) ||
    target.startsWith(`${LOGIN_ROUTE}/`)
  ) {
    return DEFAULT_LANDING_ROUTE;
  }
  return target;
};
